import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { PageLoader } from '../../components/PageLoader';
import { AccessGate } from './AccessGate';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/login',
}) => {
  const { user, loading, syncing, accessStatus } = useAuth();

  if (loading) {
    // Distinguish "warming the cache from Firestore" from generic loading so
    // returning users see what's actually happening on their first paint.
    const message = syncing && user
      ? 'Loading your past history…'
      : 'Loading...';
    return <PageLoader message={message} />;
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  // Public-deployment access gate: signed-in users without access see the
  // request-access screen instead of the protected page.
  if (accessStatus !== 'allowed') {
    return <AccessGate />;
  }

  return <>{children}</>;
};
